function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

function CopyIcon({
  height,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("rect", {
    x: ".5",
    y: "3.5",
    width: "9",
    height: "12",
    rx: "2.5",
    fill: "#EAEBEE",
    stroke: "#80878D",
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "4.5",
    y: ".5",
    width: "9",
    height: "12",
    rx: "2.5",
    fill: "#EAEBEE",
    stroke: "#80878D"
  }));
}

CopyIcon.defaultProps = {
  height: 16,
  width: 14
};
export default CopyIcon;